import React from "react";

import { connect } from "../i18n/connect";
import { actions as priceAlertActions } from "../redux/modules/priceAlerts";
import { getPriceAlertsData } from "../redux/modules/tvchartData/selector";
import withFormBuilder from "./withFormBuilder";

export default function withPriceAlertsModal(WrappedComponent) {
  const mapStateToProps = state => ({
    priceAlerts: getPriceAlertsData(state)
  });

  const mapDispatchToProps = {
    addPriceAlert: priceAlertActions.addPriceAlert,
    deletePriceAlert: priceAlertActions.deletePriceAlert
  };

  @connect(mapStateToProps, mapDispatchToProps)
  @withFormBuilder(() => [
    {
      name: "value",
      type: "newText",
      value: "",
      label: "new-price-alert-modal_price-label",
      required: false,
      fullWidth: true,
      nativeStyles: { marginBottom: 20 },
      validations: {
        customIsFloat: ({ value = "" }) => {
          const parsedValue = value.replace(",", ".");
          return !isNaN(parsedValue) ? true : "This is not a valid price";
        }
      },
      validationErrors: {
        isDefaultRequiredValue: "This field is required"
      }
    },
    {
      name: "comment",
      type: "newText",
      fullWidth: true,
      value: "",
      label: "new-price-alert-modal_comment-label",
      required: false,
      maxLength: 100
    }
  ])
  class WithPriceAlertsModal extends React.Component {
    setPrice(price) {
      const { formBuilder } = this.props;
      const priceField = formBuilder?.fields[0];

      if (
        price === null ||
        typeof price === "undefined" ||
        typeof priceField === "undefined"
      ) {
        return;
      }

      const numericPrice =
        typeof price === "number"
          ? price
          : parseFloat(String(price).replace(",", "."), 10);

      if (Number.isNaN(numericPrice)) {
        return;
      }

      const value = numericPrice.toFixed(2).toString();

      if (typeof formBuilder?.handleChange === "function") {
        formBuilder.handleChange(priceField, value);
        return;
      }

      priceField.value = value;
    }
    setComment(comment) {
      const { formBuilder } = this.props;
      const commentField = formBuilder?.fields[1];

      if (typeof comment !== "string" || typeof commentField === "undefined") {
        return;
      }

      if (typeof formBuilder?.handleChange === "function") {
        formBuilder.handleChange(commentField, comment);
        return;
      }

      commentField.value = comment;
    }
    addAlert({ fields, form, clearFormBuilder }) {
      const { addPriceAlert, stockId } = this.props;

      const payload = {
        value: fields[0].value,
        comment: fields[1].value
      };
      addPriceAlert(stockId, payload, form, clearFormBuilder);
    }
    removeAlert({ id, stockId: stockIdOverride }) {
      const { deletePriceAlert, stockId } = this.props;
      const resolvedStockId =
        typeof stockIdOverride !== "undefined" ? stockIdOverride : stockId;

      if (typeof resolvedStockId === "undefined") return;

      deletePriceAlert(resolvedStockId, id);
    }
    renewAlert({ id, value, comment, stockId: stockIdOverride }) {
      const { addPriceAlert, deletePriceAlert, stockId } = this.props;
      const resolvedStockId =
        typeof stockIdOverride !== "undefined" ? stockIdOverride : stockId;

      if (typeof resolvedStockId === "undefined") return;

      deletePriceAlert(resolvedStockId, id, true, () => {
        addPriceAlert(
          resolvedStockId,
          {
            value,
            comment
          },
          null,
          null
        );
      }, true);
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          addAlert={payload => this.addAlert(payload)}
          removeAlert={payload => this.removeAlert(payload)}
          renewAlert={payload => this.renewAlert(payload)}
          setPrice={payload => this.setPrice(payload)}
          setComment={payload => this.setComment(payload)}
        />
      );
    }
  }

  return WithPriceAlertsModal;
}
